import { Region } from '@lemon8/web-app-shared/i18n';

const getWebviewUrl = (url: string): string => {
  if (!url) return '';

  return `sslocal://webview?url=${encodeURIComponent(url)}`;
};

const getBrowserUrl = (url: string): string => {
  if (!url) return '';
  return `sslocal://system_browser_page?url=${encodeURIComponent(url)}&present_style=0`;
};

const isHttpUrl = (url: string): boolean => {
  return url.startsWith('https://') || url.startsWith('http://');
};

export const checkOpenInBrowser = (region: Region, url: string, isInApp: boolean) => {
  if (isInApp && isHttpUrl(url) && region === Region.us && url.includes('/h5/feoffline/report/email-verify/input')) {
    return true;
  }

  return false;
};

export const handleUrl = (region: Region, url: string, isInApp: boolean): string => {
  if (checkOpenInBrowser(region, url, isInApp)) {
    console.log('in checkOpenInBrowser', { region, url, isInApp });

    const urlObj = new URL(url);
    const replaceDomain = `https://v.lemon8-app.com${urlObj.pathname}?${urlObj.searchParams.toString()}`;
    return getBrowserUrl(replaceDomain);
  }

  if (isInApp && isHttpUrl(url)) {
    return getWebviewUrl(url);
  }

  return url;
};
